//@flow

const DATE_UNITS_IN_SECONDS = {
  day: 86400,
  hour: 3600,
  minute: 60,
  second: 1,
};

const getUnitAndValueDate = (secondsElapsed: number) => {
  for (const [unit, secondsInUnit] of window.Object.entries(
    DATE_UNITS_IN_SECONDS
  )) {
    if (secondsElapsed >= secondsInUnit || unit === 'second') {
      const value = Math.floor(secondsElapsed / secondsInUnit) * -1;
      return {value, unit};
    }
  }
};

export type TimeAgoOptions = {
  localeMatcher?: 'lookup' | 'best fit',
  numeric?: 'always' | 'auto',
  style?: 'long' | 'short' | 'narrow',
  lang?: string,
};

export function timeAgo(
  timestamp: number,
  options: TimeAgoOptions = {}
): string {
  if (!timestamp) return '';
  const {lang = 'es-PE', ...formatOptions} = options;
  const rtf = new window.Intl.RelativeTimeFormat(lang, {
    localeMatcher: 'best fit',
    numeric: 'always',
    style: 'long',
    ...formatOptions,
  });

  const secondsElapsed = (Date.now() - timestamp) / 1000;

  const valueDate = getUnitAndValueDate(secondsElapsed);

  if (!valueDate) return 'Ahora';

  const {value, unit} = valueDate;

  return rtf.format(value, unit);
}
